/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * All of the possible `StatusBadgeStatus*`'s.
 */
export type TooltipPositionType =
  | TooltipPositionTypeBottom
  | TooltipPositionTypeLeft
  | TooltipPositionTypeRight
  | TooltipPositionTypeTop;

/**
 * The Tooltip bottom position type.
 */
export type TooltipPositionTypeBottom = typeof TOOLTIP_POSITION_BOTTOM;

/**
 * The Tooltip left position type.
 */
export type TooltipPositionTypeLeft = typeof TOOLTIP_POSITION_LEFT;

/**
 * The Tooltip right position type.
 */
export type TooltipPositionTypeRight = typeof TOOLTIP_POSITION_RIGHT;

/**
 * The Tooltip top position type.
 */
export type TooltipPositionTypeTop = typeof TOOLTIP_POSITION_TOP;

/**
 * The Tooltip bottom position constant.
 */
export const TOOLTIP_POSITION_BOTTOM = `bottom`;

/**
 * The Tooltip left position constant.
 */
export const TOOLTIP_POSITION_LEFT = `left`;

/**
 * The Tooltip right position constant.
 */
export const TOOLTIP_POSITION_RIGHT = `right`;

/**
 * The Tooltip top position constant.
 */
export const TOOLTIP_POSITION_TOP = `top`;
